import { useEffect, useRef, useState } from "react";
import apiInstance from "../../apiInstance";
import PopupModal from "../Popups/PopupModal";

const DevadminWebsites = () => {
    const [websites, setWebsites] = useState([]);
    const [inQueueCount, setInQueueCount] = useState(0);
    const [generatedCount, setGeneratedCount] = useState(0);
    const [interestedCount, setInterestedCount] = useState(0);
    const [claimedCount, setClaimedCount] = useState(0);
    const [pausedCount, setPausedCount] = useState(0);
    const [totalWebsites, setTotalWebsites] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sitesPerPage, setSitesPerPage] = useState(50);
    const [selectedWebsites, setSelectedWebsites] = useState([]);
    const [bulkAction, setBulkAction] = useState("");
    const [reload, setReload] = useState(0);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [filters, setFilters] = useState({
        status: ""
    });
    const [error, setError] = useState("");
    const popupRef = useRef();

    const generateWebsites = () => {
        const generateSpinner = document.getElementById("mjs-dev-sitegen-spin");
        if (generateSpinner) generateSpinner.style.display = "inline-block";

        apiInstance
            .put("/devadmin/generate")
            .then((response) => {
                const totalSites = response.data.totalSites || 0;
                console.log(`Total Sites in CSV: ${totalSites}`);
                
                const newWebsites = response.data.websites || [];
                console.log(`Sites added to Queue: ${newWebsites.length}`);

                const skippedWebsites = response.data.skipped || [];
                if(skippedWebsites.length > 0){
                    console.log(`Sites Skipped: ${skippedWebsites.length}`);
                    //skippedWebsites.forEach((item, index) => {
                      //  console.log(`Skipped #${index + 1}:`, item);
                    //});
                }

                setReload(prev => prev + 1);
            })
            .catch((error) => {
                console.error("Error generating websites:", error);
                setError("Error generating websites.");
            })
            .finally(() => {
                if (generateSpinner) generateSpinner.style.display = "none";
            });
    };

    const deleteWebsiteHandler = (websiteId, counts) => {
		setReload(prev => prev + 1);
		
    }

    const updateWebsiteHandler = (website, counts) => {
        const updatedWebsites = websites.map(item => item._id === website.id ? {...item, ...website} : item);
        setWebsites(updatedWebsites)
        setInQueueCount(counts.inQueue);
		setGeneratedCount(counts.generated);
		setInterestedCount(counts.interested);
		setClaimedCount(counts.claimed);
        setPausedCount(counts.paused);
    }

    const handleSelectAll = (e) => {
        if(e.target.checked) {
            const allWebsiteIds = websites.map((item) => item._id);
            setSelectedWebsites(allWebsiteIds);
        } else {
            setSelectedWebsites([]);
        }
    }

    const handleSelect = (websiteId) => {
        setSelectedWebsites(prevSelected => {
            if (prevSelected.includes(websiteId)) {
                return prevSelected.filter(id => id !== websiteId);
            } else {
                return [...prevSelected, websiteId];
            }
        });
    };

    const handleBulkAction = async () => {
        switch(bulkAction) {
            case "delete":
                const updatedWebsites = [...websites];
                for (const websiteId of selectedWebsites) {
                    try {
                        const res = await apiInstance.delete(`/devadmin/website/${websiteId}`);

                        setWebsites(prev =>
                            prev.filter(site => site._id !== websiteId)
                        );
                    } catch (error) {
                        console.error(`Error deleting website:`, error);
                        setError(`Error deleting website ${websiteId}.`);
                    }
                }
                setReload(prev => prev + 1);
                break;
        }
    }

    const handleCurrentPageChange = (p) => {
        const totalPages = Math.ceil(totalWebsites / sitesPerPage);
        const value = Math.min(totalPages, Math.max(1, p));
        setCurrentPage(value);
        setSelectedWebsites([]);
    }

    const renderPaginationControls = () => {

        let totalPages = 0;
        let startItem = 0;
        let endItem = 0;
        if(totalWebsites > 0) {
            totalPages = Math.ceil(totalWebsites / sitesPerPage);
            startItem = (currentPage - 1) * sitesPerPage + 1;
            endItem = Math.min(currentPage * sitesPerPage, totalWebsites);
        }

        return (
            <div className="mjsdev-webs-pagination-wrapper">
                Per Page
                <select 
                    value={sitesPerPage} 
                    onChange={(e) => {
                        setSitesPerPage(Number(e.target.value));
                        handleCurrentPageChange(1); 
                    }} 
                >
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                </select>
                <span>
                    Showing {startItem}-{endItem} of {totalWebsites}
                </span>
                <button onClick={() => handleCurrentPageChange(1)} disabled={currentPage === 1}>
                    &laquo; 
                </button>
                <button 
                    onClick={() => handleCurrentPageChange(currentPage - 1)} 
                    disabled={currentPage === 1}
                >
                    &lsaquo; 
                </button>                
                <input
                    type="number"
                    value={currentPage}
                    onChange={(e) => handleCurrentPageChange(Number(e.target.value))}
                />
                <span>
                    of {totalPages}
                </span>
                <button 
                    onClick={() => handleCurrentPageChange(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                >
                    &rsaquo;
                </button>
                <button onClick={() => handleCurrentPageChange(totalPages)} disabled={currentPage === totalPages}>
                    &raquo;
                </button>
            </div>
        );
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearch(search || "");
        }, 400); 

        return () => clearTimeout(timeout);
    }, [search]);

    useEffect(() => {
        const fetchWebsites = async () => {
            apiInstance
                .get(`/devadmin/website`, {
                    params: {
                        page: currentPage,
                        limit: sitesPerPage,
                        search: debouncedSearch,
                        ...filters
                    }
                })
                .then((response) => {
                    const fetchedWebsites = response.data.websites || [];
                    setWebsites(fetchedWebsites);
                    setTotalWebsites(response.data.pagination.total || 0);
                    setInQueueCount(response.data.counts.inQueue || 0);
                    setGeneratedCount(response.data.counts.generated || 0);
                    setInterestedCount(response.data.counts.interested || 0);
                    setClaimedCount(response.data.counts.claimed || 0);
                    setPausedCount(response.data.counts.paused || 0);
                    setSelectedWebsites([]);
                    
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load websites.");
                });
        }
        fetchWebsites();
		
    }, [currentPage, sitesPerPage, reload, filters, debouncedSearch]);

    return (
        <>
            <div className="mjsdev-main">
                <div className="mjsdev-webs-header">
                    <div className="mjsdev-webs-header-count">
                        <span>In Queue: {inQueueCount || 0}</span>
                        <span>Generated: {generatedCount || 0}</span>
                        <span>Interested: {interestedCount || 0}</span>
                        <span>Claimed: {claimedCount || 0}</span>
                        <span>Paused: {pausedCount || 0}</span>
                    </div>
                    <div className="mjsdev-webs-header-gen-sec">
                        <i id="mjs-dev-sitegen-spin" className="mjs-hidden fa-solid fa-spinner fa-spin"></i>
                        <button className="mjs-btn mjsdev-gen-website" onClick={generateWebsites}>Generate Websites</button>
                    </div>
                </div>

                <div className="mjsdev-webs-toolbar">
                    <div className="mjsdev-webs-bulk_actions">
                        <select
                            value={bulkAction}
                            onChange={(e) => setBulkAction(e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value="delete">Delete</option>
                        </select>
                        <button
                            className="mjs-btn"
                            onClick={handleBulkAction}
                            disabled={!bulkAction || selectedWebsites.length === 0}
                        >
                            Apply
                        </button>
                    </div>
                    
                    <div className="mjsdev-webs-filters">
                        <div className="mjsdev-search-wrapper">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1); 
                                }}
                            />
                            {search && (
                                <i
                                    className="fa-solid fa-times"
                                    onClick={() => setSearch("")}
                                    title="Clear search"
                                ></i>
                            )}
                        </div>
                        <select
                            value={filters.status}
                            onChange={(e) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    status: e.target.value
                                }))
                                setCurrentPage(1); 
                            }}
                        >
                            <option value="">All Status</option>
                            <option value="in_queue">In Queue</option>
                            <option value="generated">Generated</option>
                            <option value="interested">Interested</option>
                            <option value="claimed">Claimed</option>
                            <option value="paused">Paused</option>
                        </select>
                    </div>

                    <div className="mjsdev-webs-pgn-top">
                        {renderPaginationControls()}
                    </div>
                </div>

                {error && <p className="mjs-error">{error}</p>}

                <table className="mjsdev-table">
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={websites.length > 0 && selectedWebsites.length === websites.length}
                                />
                            </th>
                            <th>Site Name</th>
                            <th>Date</th>
                            <th>Owner</th>
                            <th>Status</th>
                            <th>Note</th>
                            <th></th>
                        </tr>
                    </thead>
                    {websites.length > 0 ? (
                        <tbody>
                            {websites.map((website, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            onChange={() => {handleSelect(website._id)}}
                                            checked={selectedWebsites.includes(website._id)}
                                        />
                                    </td>
                                    <td>
                                        <a
                                            href={website.siteUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {website.name || "-"}
                                        </a>
                                    </td>
                                    <td>
                                        {website.createdAt
                                            ? new Date(
                                                website.createdAt
                                            ).toDateString()
                                            : "—"}
                                    </td>
                                    <td>
                                        {website.owner_id?.email || "Not claimed"}
                                    </td>
                                    <td>
                                        {website.status || "N/A"}
                                    </td>
                                    <td>{website.note || ""}</td>
                                    <td className="mjsdev-table-actions">
                                        {website.status === 'paused' &&
                                            <i 
                                                title='Resume Website' 
                                                class="fa-solid fa-play" 
                                                style={{color:'#2ecc71'}}
                                                onClick={() => {
                                                    if (popupRef.current) {
                                                        popupRef.current.openPopup(
                                                            "resumeWebsite",
                                                            { website }
                                                        );
                                                    }
                                                }}
                                            ></i>
                                        }
                                        {website.status !== 'paused' &&
                                            <i 
                                                title='Pause Website' 
                                                className="fa-solid fa-pause" 
                                                style={{color:'#e63946'}}
                                                onClick={() => {
                                                    if (popupRef.current) {
                                                        popupRef.current.openPopup(
                                                            "pauseWebsite",
                                                            { website }
                                                        );
                                                    }
                                                }}
                                            ></i>
                                        }
                                        <i
                                            onClick={() => {
                                                if (popupRef.current) {
                                                    popupRef.current.openPopup(
                                                        "editWebsite",
                                                        { website }
                                                    );
                                                }
                                            }}
                                            title="Edit Site"
                                            className="fa-solid fa-pen-to-square"
                                        ></i>
                                        <i
                                            onClick={() => {
                                                if (popupRef.current) {
                                                    popupRef.current.openPopup(
                                                        "deleteWebsite",
                                                        { websiteId: website._id }
                                                    );
                                                }
                                            }}
                                            title="Delete Site"
                                            className="fa-solid fa-trash"
                                        ></i>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <p className="mjsdev-msg">No websites found.</p>
                    )}
                </table>
                
                <div className="mjsdev-webs-pgn-bottom">
                    {renderPaginationControls()}
                </div>
            </div>
            <PopupModal
                ref={popupRef}
                deleteWebsite={deleteWebsiteHandler}
                updateWebsite={updateWebsiteHandler}
            />
        </>
    );
};

export default DevadminWebsites;
